import { useTranslation } from 'react-i18next';
import { useUserRoles } from '@anytag/auth';
import { Form } from '@anytag/shared-atoms';
import { FormAction } from '@anytag/shared-types';
import { cn, getSubscriptionTypeLabel } from '@anytag/shared-utils';
import { AnalyticsSubscriptionPlanType } from '@anytag/graphql';
import { Template } from './Template';
import { AdvertiserFormValues } from './types';
import { AdvertiserFormBasedOnIdSchema } from './schema';

export interface AdvertiserFormProps extends FormAction<AdvertiserFormValues> {
  subscriptionType?: AnalyticsSubscriptionPlanType;
  className?: string;
}

export const AdvertiserForm = ({ onSubmit, defaultValues, subscriptionType, className }: AdvertiserFormProps) => {
  const { t } = useTranslation();
  const { isTalentAgencyPartner } = useUserRoles();

  const planTitle = getSubscriptionTypeLabel(subscriptionType);

  return (
    <div className={cn('flex gap-6', className)}>
      <Form.Provider<AdvertiserFormValues>
        className="flex-1"
        onSubmit={onSubmit}
        zodSchema={AdvertiserFormBasedOnIdSchema}
        defaultValues={{
          type: defaultValues?.type || 'add',
          advertiserId: defaultValues?.advertiserId,
          advertiserName: defaultValues?.advertiserName || '',
          isNewlyCreated: undefined,
          shouldSendInvitation: true,
          hubspotId: defaultValues?.hubspotId || '',
          countryId: defaultValues?.countryId || '',
          companyUrl: defaultValues?.companyUrl || '',
          phoneNumber: defaultValues?.phoneNumber || '',
          internalNetsuiteId: defaultValues?.internalNetsuiteId || '',
          ...(defaultValues?.type === 'add' && {
            password: '',
            passwordConfirm: '',
            email: defaultValues.email,
            userName: defaultValues.userName
          })
        }}
      >
        <Template className="form-container" />
      </Form.Provider>

      {isTalentAgencyPartner && (
        <div className="box-border flex h-max w-92 flex-none flex-col gap-4 rounded-b-sm bg-white p-6 shadow-base">
          <Form.SectionTitle label={t('Account Manager Plan')} className="mb-0" />

          {planTitle ? (
            <span className="mx-auto text-lg font-semibold">{t(planTitle)}</span>
          ) : (
            <span className="text-base font-normal">{t('No plan subscription')}</span>
          )}
          <p className="text-sm font-normal text-tertiary">{t('Please contact our staff to upgrade subscriptions')}</p>
        </div>
      )}
    </div>
  );
};

export * from './types';
